import { useEffect, useRef } from "react";
import { useWaterSystemSearchModal } from "../reuseableComponents/WaterSystemSearchModalContext";
import { ReportSection } from "../reuseableComponents/monitoringReport/ReportSection";
import { GET_GROUPED_SOURCE_SAMPLING_STATIONS } from "../../queries/publicQrys/WaterSystemReportQrys";
import { useLazyQuery } from "@apollo/client";

export const GroupedSourceSamplingTable = () => {
  // Get data for Grouped Source Sampling Stations, build data object to pass into ReportSection
  const selectedWaterSystem = JSON.parse(sessionStorage.getItem("selectedWaterSystem") || "{}");
  const { showSystemSelectModal, setShowSystemSelectModal } = useWaterSystemSearchModal();
  const [getGroupedSourceSamplingStations, { data: GroupedSourceSamplingData }] = useLazyQuery(GET_GROUPED_SOURCE_SAMPLING_STATIONS);
  const lastFetchedSystemNumber = useRef(null);

    // Only open modal if not already open and no system is selected
  useEffect(() => {
    if (
      (!selectedWaterSystem || Object.keys(selectedWaterSystem).length === 0) &&
      !showSystemSelectModal
    ) {
      setShowSystemSelectModal(true);
    }
    // Do NOT fetch report if no system is selected
  }, [setShowSystemSelectModal, selectedWaterSystem, showSystemSelectModal]);

  // Fetch report when a system is selected, or when selectedWaterSystem changes
  useEffect(() => {
    if (
      selectedWaterSystem &&
      Object.keys(selectedWaterSystem).length > 0 &&
      selectedWaterSystem.pwsId &&
      selectedWaterSystem.pwsId !== lastFetchedSystemNumber.current
    ) {
      getGroupedSourceSamplingStations({ variables: { pwsId: selectedWaterSystem.pwsId } });
      lastFetchedSystemNumber.current = selectedWaterSystem.pwsId;
    }
  }, [selectedWaterSystem, getGroupedSourceSamplingStations]);

  const groupedSourceSamplingStationDataRaw = GroupedSourceSamplingData?.getGroupedSourceSamplingStations || [];
  const gridData = {
    headers: ['Sample Station ID', 'Sample Station Name', 'Sample Station Activity Status'],
    rows: groupedSourceSamplingStationDataRaw.map((station, index) => {
      return {
        id: `${station.sampleStationId}-${index}`,
        cells: [
          station.facilityCode,
          station.facilityName,
          station.activityStatus
        ],
        secondaryGrid: station.samplingStations && station.samplingStations.length > 0 ? {
          isCollapsible: false,
          headers: ['Source Facility ID', 'Source Name'],
          rows: station.samplingStations.map((samplingStation, idx) => {
            return {
              id: `${samplingStation.sourceFacilityId}-${idx}`,
              cells: [
                samplingStation.sourceFacilityId,
                samplingStation.sourceName
              ]
            };
          }) || []
        } : {}
      };
    }),
  };

  return (
    <div>
      <ReportSection 
        key="0"
        title="Group Source Sampling Stations"
        gridData={gridData}
      />
    </div>
  );
};
